import type { FaireProductEntity } from "../../entity_types/product";

export const p_ao37ksak: FaireProductEntity = {
  token: "p_ao37ksak",
  type: "product",
  name: "Laundry Soap 64 oz",
  brandToken: "b_1kcui4ks",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/9dff2350976b6960c1a55394cd8165e7f29754cdbb8694fe9e30acb0d30616cf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/b5a417239c1e388b7060ff147d7c7265a2f57b5cb58e2f09194ddaf62d827dfd/1540299323.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/5e398eba3ee00b5584448f64c7c0316e795548125c9e219b47ac9145ba005e82/1551153544.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/60782601d8b2d7eb30af852a28fe066921bdfb2031fa8a3e70c267cc857fd056/1551153551.jpg",
    "https://cdn.faire.com/fastly/f066a57dc926a2973789f9e6445c254152905d093af4efd1b27f97c66936118b.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/4b03d47d7efb080c1262e15e63d2fea3ae5a347a8a57d770c7194a8388cc5367/1551153533.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/baf7ed620d35089952d624abca6829659aae0e87255e134e3d1a81b848b6c500/1528513474.png",
  ],
  priceDollars: 15,
  description:
    "Formulated based on our own need for a laundry soap that would clean our cloth diapers (so yeah, think about how well it must work) but it had to be gentle enough to not irritate our baby's skin. We didn't want to add to the labor of laundry by using two different detergents.\n  \nIf MamaSuds Laundry Soap can clean cloth diapers, imagine how it can clean your regular laundry.\n\nINGREDIENTS: water, potassium olivate (saponified olive oil), sodium carbonate,  sodium borate (pure essential oils of lemon or lavender if applicable)\n\n-64 fluid ounce BPA-free + recyclable bottle\n-Options for unscented, or pure lavender or lemon essential oil\n-HE (High-efficiency) safe\n-SLS-free, Dye-free, phthalate-free, sulfate-free\n-Biodegradable and safe for septic systems\n-Safe for grounding sheets and EMF protective clothing\n-64 fluid ounce bottle will do up to 128 loads of laundry (for High-Efficiency washers)",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:10.035Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
